import React from 'react'

const PlaylistLoadingCards = () => {
  const cardArray = new Array(6).fill(null)

  return (
    <ul className='PlaylistSelector__loadingRows'>
      {cardArray.map((_, idx) => <li key={idx} className='PlaylistSelector__loading' />)}
    </ul>
  )
}

export default PlaylistLoadingCards
